import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "./assets/theme/index.css";
import globalComponents from '@/util/globalComponents'
import utilPrototype from '@/util/utilPrototype'
import { VueJsonp } from 'vue-jsonp'    // 调用腾讯地图跨域问题解决
Vue.config.productionTip = false
Vue.use(VueJsonp)
Vue.use(globalComponents);
Vue.use(ElementUI);
Vue.use(utilPrototype);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/* router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    sessionStorage.removeItem('SAASTOKEN');
  } else {
    if (!sessionStorage.getItem('SAASTOKEN')) {
      //访问服务器缓存数据，判断当前token是否失效
      next('/login');
    }
  }
  next();
  // NProgress.start() // start progress bar
})
router.afterEach(() => {
  // NProgress.done() // finish progress bar
}) */